import { render, staticRenderFns } from "./categoryDialog.vue?vue&type=template&id=5a38114d&scoped=true"
import script from "./categoryDialog.vue?vue&type=script&lang=js"
export * from "./categoryDialog.vue?vue&type=script&lang=js"
import style0 from "./categoryDialog.vue?vue&type=style&index=0&id=5a38114d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38114d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a38114d')) {
      api.createRecord('5a38114d', component.options)
    } else {
      api.reload('5a38114d', component.options)
    }
    module.hot.accept("./categoryDialog.vue?vue&type=template&id=5a38114d&scoped=true", function () {
      api.rerender('5a38114d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/components/categoryDialog.vue"
export default component.exports